import React from 'react'
import support from '../icons/Support.svg'
import logo from '../icons/logo.jpeg'
import { Link, NavLink } from 'react-router-dom'

const Header = () => {
    return (
        <header className="bg-white shadow-sm border-b border-gray-200">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between items-center h-20">
                    
                    {/* Logo */}
                    <div className="flex-shrink-0">
                        <NavLink to="/host" className="block">
                            <img 
                                className="h-12 w-auto" 
                                src={logo} 
                                alt="Bellhopt Logo" 
                            />
                        </NavLink>
                    </div>

                    {/* Support Link */}
                    <div className="flex items-center">
                        <Link 
                            to="/support"
                            className="flex items-center space-x-2 px-4 py-2 rounded-lg text-gray-600 hover:text-gray-900 hover:bg-gray-50 transition-colors"
                        >
                            <img 
                                src={support} 
                                alt="Support" 
                                className="w-5 h-5"
                            />
                            <span className="font-medium">Support</span>
                        </Link>
                    </div>
                </div>
            </div>
        </header>
    )
}

export default Header